import { useIsAcomba } from './useIsAcomba';
import { useTasksStore } from '../stores/tasksStore';

/**
 * Whether the Encaisser action should be shown for a relance row. Requires both: no desktop
 * bridge session (no AcombaGO payment window for the button to route through), and the AcombaGO
 * user allowed to open the payment window (`canCollectPaymentAccessible`, AcombaGO's own
 * user-level answer to whether this user may open it at all). The permission signal fails open to
 * `true` while unresolved.
 */
export const useCanCollectPayment = (): boolean => {
    const isAcomba = useIsAcomba();
    const canCollectPaymentAccessible = useTasksStore(s => s.dailyTasks?.canCollectPaymentAccessible ?? true);
    return !isAcomba && canCollectPaymentAccessible;
};
